import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Onoff from "./blockPills";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import DeletePop from "./deletePopUp";
import Utils from "../../../utility";
import { hashtagListingService } from "../../../services/index";
import { blockHashtagService } from "../../../services/index";
import Loader from "../../../common/components/tablesLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
  Card: {
    maxHeight: 20,
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },

  link: {
    "& > * + *": {
      marginLeft: theme.spacing(51),
    },
  },
  Table: {
    "&:nth-of-type(odd)": {
      backgroundColor: "white",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "red",
    },
  },
  Deleteicon: {
    color: "grey",
    "&:hover, &.Mui-focusVisible": { color: "#FF0027" },
  },
}));

const WebView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 1024px) {
    display: none;
  }
  @media (min-width: 1025px) {
    display: visible;
  }
`;

const TabView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 1024px) {
    display: visible;
  }
  @media (min-width: 1025px) {
    display: none;
  }
`;

export default function StickyHeadTable(props) {
  const preventDefault = (event) => event.preventDefault();
  const classes = useStyles();
  const [hashtagListing, sethashtagListing] = React.useState([]);
  const [activeHashCount, setActiveHashCount] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  
  // useEffect(() => {
  //   let data = {
  //     pageNum: page,
  //     perpage: activeHashCount,
  //   };
  //   gethashtagListing(data);
  // }, [activeHashCount]);

  // const gethashtagListing = async (data) => {
  //   let [error, Hashtags] = await Utils.parseResponse(
  //     hashtagListingService.gethashtagListing(data)
  //   );
  //   setActiveHashCount(Hashtags?.activeCount);
  //   if (error || !Hashtags) return;
  // };
  
  return (
    <Paper elevation={0} className={classes.root}>
      <Card className={classes.Card}>
        <Typography
          className={classes.link}
          variant="h8"
          color="#001441"
        ></Typography>
      </Card>

      <TableContainer className={classes.container}>
        <WebView>
          <Table
            stickyHeader
            aria-label="sticky table"
            className={classes.Table}
          >
            <TableHead>
              <TableRow>
                <TableCell align="left" id="Table-cell" className="w-43">
                  Hashtag Name
                </TableCell>
                <TableCell align="left" id="Table-cell" className="w-36">
                  Videos Created
                </TableCell>
                <TableCell align="center" id="Table-cell">
                  Block Hashtag
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="table-body">
              {props?.isLoading ? (
                <TableRow>
                  <TableCell style={{ border: "none" }} colspan={12}>
                    <div className="homePageLoader">
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                
                props.hashtagListing?.length !==0?
                props.hashtagListing?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    if (row.isActive === true)
                      return (
                        <>
                          <TableRow className="table-row">
                            <TableCell align="left" className="Table-cell">
                              {row.hashTag}
                            </TableCell>
                            <TableCell align="left" className="Table-cell">
                              {row.__v}
                            </TableCell>
                            <TableCell align="center" className="Table-cell">
                              <Onoff
                                row={row._id}
                                gethashtagListing={props.gethashtagListing}
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      );
                  })
                  :( <TableRow>
                    <TableCell style={{ border: "none" }} colspan={12}>
                      <div className="homeSellBuyTable">
                        <center>No data found</center>
                      </div>
                    </TableCell>
                  </TableRow>)
              )}
            </TableBody>
          </Table>
        </WebView>

        <TabView>
          <Table
            stickyHeader
            aria-label="sticky table"
            className={classes.Table}
          >
            <TableHead>
              <TableRow>
                <TableCell align="left" id="Table-cell" className="w-43">
                  Hashtag Name
                </TableCell>
                <TableCell align="left" id="Table-cell" className="w-36">
                  Videos Created
                </TableCell>
                <TableCell align="center" id="Table-cell">
                  Block Hashtag
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="table-body">
              {props?.isLoading ? (
                <TableRow>
                  <TableCell style={{ border: "none" }} colspan={5}>
                    <div className="homePageLoader">
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                props?.tabActiveHashtagListing?.length !==0?
                props?.tabActiveHashtagListing?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    if (row.isActive === true)
                      return (
                        <>
                          <TableRow className="table-row">
                            <TableCell align="left" className="Table-cell">
                              {row.hashTag}
                            </TableCell>
                            <TableCell align="left" className="Table-cell">
                              {row.__v}
                            </TableCell>
                            <TableCell align="center" className="Table-cell">
                              <Onoff
                                row={row._id}
                                gethashtagListing={
                                  props.getTabActiveHashtagListing
                                }
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      );
                  }):( <TableRow>
                    <TableCell style={{ border: "none" }} colspan={12}>
                      <div className="homeSellBuyTable">
                        <center>No data found</center>
                      </div>
                    </TableCell>
                  </TableRow>)
              )}
            </TableBody>
          </Table>
        </TabView>
      </TableContainer>
      <TablePagination
        id="test"
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={props?.activeHashCount || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
